import React from 'react'
import { MdArrowBackIosNew } from "react-icons/md";


function QuranShareef() {
  return (
    <div className='contain'>
        <div className="page-header">
          <span className="backBtn" onClick={()=> window.history.back()}>
            <MdArrowBackIosNew />
          </span>
          <div className="page-header__content">
            <h1 className="pagetitle">Quran Shareef Padhne Ki Fazilat</h1>
          </div>
       </div>
       <div className="contentSection-card">
        <h3 className='contentSection_subtitle'>✨Rozana Qur'an Shareef Padhna ✨</h3>
            <p className="contentSection_title--content">
            “ Rozana Quran-E-Azeem ki tilawat kiya karo isliye ke Hadees Shareef me Aaya hai 
            Rasool Allah صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne farmaya Quran padha karo isliye ke ye Quran qayamat
             ke din Quran padhne walo ki shafa'at karega.
             <span className="referenceTag">[ Muslim Shareef : 804 ]</span>
            </p>
            <p className="contentSection_title--content">
            Hazrat Ayesha Siddiqa radiallahu anha riwayat karti hai ke NABI-E-KAREEM صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne 
            farmaya, Quran ka mahir moazzaz wa mohtaram farishto aur moazzam wa mukarram Ambiya ke sath hoga
             aur wo shakhs jo Quran padhta ho lekin (kam zehni ya moti zaban ki wajah se) atakta ho aur us
              par (padhna) mushkil ho toh uske liye bhi (padhne ka) 2 guna(double) ajr(sawab) hai.
            </p>
            <span className="referenceTag">[ Muslim Shareef :798 ]</span>
            <p className="contentSection_title--content">
            Huzoor NABI-E-KAREEM صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne irshad farmaya, tum me se behtar wo 
            shaksh hai jo Quran seekhe aur sikhaye.
            </p>
            <span className="referenceTag">[ Bukhari Shareef :5028 ]</span>
            <p className="contentSection_title--content">
            short description :
            </p>
            <p className="contentSection_title--content">
            Quran pak me :
            </p>
            <p className="contentSection_title--content">
                    Pare=30 <br />
                    Sajde=14<br />
                    Manzil=7<br />
                    Surah=114<br />
                    Makki Surah=86<br />
                    Madni Surah=28<br />
                    Ruku=540<br />
                    Aayat=6666
            </p>
            
            <p className="contentSection_title--content">
            Hazrat Abdullah ibn e Mas'ud رضی اللہ عنہ se riwayat hai ke NABI-E-KAREEM صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne
             farmaya, "Jisne ALLAH ki kitab(Quran Shareef) se ek harf padha, uske liye iske badle me ek neki
              hai aur ye ek neki 10 nekiyo ke barabar hai. Mai ye nahi kahta ke ALIF-LAAM-MEEM ek harf hai, 
              balke ALIF ek harf hai, LAAM ek harf hai aur MEEM ek harf hai." (Yaani sirf ALIF-LAAM-MEEM 
              padhne se 30 nekiya mil jati hai. SUBHAN ALLAH)
              </p>
            <span className="referenceTag">[ SUNAN TIRMIZI : 2910 ]</span>
            <p className="contentSection_title--content">
            Huzoor NABI-E-KAREEM صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne irshad farmaya, jisne surah al-baqrah ki 2 aakhiri 
            aayate raat me padh li wo ise har aafat se bachane ke liye kafi ho jayengi.
            </p>
            <span className="referenceTag">[ Sahih Bukhari : 5009 ]</span>
            <p className="contentSection_title--content">
            Huzoor NABI-E-KAREEM صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم raat ko ek safar me ja rhe the , Hazrat Umar bin 
            khattab ( رضی اللہ عنہ) bhi Aap ke sath the, Hazrat Umar ( رضی اللہ عنہ) ne 
            Aap صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم se kuch poocha, lekin Nabi-E-Kareem صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne koi jawab 
            na diya,Hazrat Umar ( رضی اللہ عنہ) ne fir poocha, Aap صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne fir koi jawab
             nahi diya. Teesri martaba fir poocha aur jab is martaba bhi koi jawab nahi diya to 
             Hazrat Umar ( رضی اللہ عنہ) ne apne app se kaha teri maa tujh par roye tune
              Huzoor NABI-E-KAREEM صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم se 3 martaba aajizi se sawal kiya aur
               NABI-E-KAREEM صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne kisi martaba bhi jawab nahi diya.
                Hazrat Umar ( رضی اللہ عنہ) ne bayan kiya ki fir maine apni ootni ko daudaya aur logo se 
                aage ho gaya (Aap ke barabar chalna chhod diya) Mujhe khauf tha ki kahi is harkat par mere 
                bare me koi aayat nazil na ho jaye, abhi thoda hi waqt guzra tha ki maine ek pukarne wale
                 ko suna jo pukar raha tha. Hazrat Umar ( رضی اللہ عنہ) ne bayan kiya ki maine socha 
                 mujhe to khauf tha hi ki mere bare me kuch (وحی ) wahi nazil hogi,Hazrat Umar
                  ( رضی اللہ عنہ) ne bayan kiya ki Mai Rasool-E-Akram صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ki khidmat 
                  me aaya aur maine aapko salam kiya (salam ke jawab ke baad) Nabi-E- Kareem 
                  صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne farmaya, Ae Umar ( رضی اللہ عنہ) ! aaj raat mujh par 
                  aisi surat nazil hui hai jo mujhe un sab cheezo se zyada pasand hai jinpar 
                  suraj nikalta hai. fir Aap ne Suarh Fateh «إنا فتحنا لك فتحا مبينا» ki tilawat 
                    farmayi.
            </p>
            <span className="referenceTag">[Sahih Bukhari : 5012 ]</span>
            <p className="contentSection_title--content">
            Huzoor Nabi-E-Kareem صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne irshad farmaya,surah ikhlaas
             (قل هو الله أحد)(qul huwal laahu ahad) Quran Majeed ke ek tihayi 
             [equal to one-third (1/3) ] hisse ke barabar hai.
            </p>
            <span className="referenceTag">[ Sahih Bukhari : 5013 ]</span>
            <p className="contentSection_title--content">
            Huzoor Nabi-E-Kareem صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne apne Sahaba se farmaya ki kya tum me se kisi ke 
            liye ye mumkin nahi ki Quran ka ek tihaayi (1/3) hissa ek raat me padha kare ? Sahaba-E-kiraam 
            ko ye amal bada mushkil maloom hua aur unhone arz kiya: Ya Rasool Allah صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ! 
            ham me se kon iski taqat rakhta hai.Huzoor Nabi-E-Kareem صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne is par 
            farmaya ki الواحد الصمد yaani (قل هو الله أحد) (qul huwal laahu ahad) Quran Majeed ka
             ek tihayi hissa hai [equal to one-third (1/3) ].
            </p>
            <span className="referenceTag">[ Sahih Bukhari : 5015 ]</span>
            <p className="contentSection_title--content">
            Ummul Momineen Hazrat Ayesha Siddiqa (رضی اللہ عنہا ) riwayat karti hai ke 
            NABI-E-KAREEM صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم har raat jab bistar par aaram farmate to apni 
            dono hatheliyo ko mila kar Surah ikhlaas (Surah No. 112 ), Surah Falaq (Surah No. 113 ) 
            aur Surah Naas (Surah No. 114 ) «قل هو الله أحد»، «قل أعوذ برب الفلق» اور «قل أعوذ برب الناس» teeno
             surate makammal padh kar un par (hatheliyo par) fookte aur fir dono hatheliyo ko jahan tak mumkin 
             hota apne jism par ferte, pahle sar aur chehra-E-Mubarak par hath ferte aur saamne ke badan par. 
             ye amal Aap صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم (3 times) 3 dafa karte.
            </p>
            <span className="referenceTag">[ Sahih Bukhari : 5017 ]</span>
            <p className="contentSection_title--content">
            Huzoor NABI-E-KAREEM صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne farkimaya ki us Momin ki misaal jo Quran Shareef 
            ki tilawat karta hai , santare (orange) ki si hai jiska maza bhi lazeez hota hai aur jiski
             khushbu bhi behtareen hoti hai aur jo Momin Quran Shareef ki tilawat nahi karta hai uski 
             misaal khajoor (dates) ki si hai uska maza to umda hota hai lekin usme khushbu nahi hoti.
            </p>
            <span className="referenceTag">[ Sahih Bukhari : 5020 ]</span>
            <p className="contentSection_title--content">
            Hazrat Abdullah ibn e Abbas رضی اللہ عنہ se riwayat hai ke NABI-E-KAREEM 
            صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne farmaya, " Wo shakhs jiske dil me Quran ka kuch hissa bhi nahi wo
             veeran ghar ki tarah hai."
            </p>
            <span className="referenceTag">[ SUNAN TIRMIZI : 2913 ]</span>
            <p className="contentSection_title--content">
            Hazrat Abdullah ibn e Amir رضی اللہ عنہ se riwayat hai ke NABI-E-KAREEM صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne
             farmaya, "Quran padhne wale se kaha jayega, Quran padhta ja aur Jannat me manzil ba-manzil upar
              chadhta ja aur yu tarteel se chadh, jaise tu duniya me tarteel kiya karta tha. Jannat me tera
               thikana waha par hoga jaha tu aakhri aayat tilawat karega."
            </p>
            <span className="referenceTag">[ SUNAN TIRMIZI : 2914 ]</span>
            <p className="contentSection_title--content">
            Hazrat Sahal Bin Muaz رضی اللہ عنہ apne walid se riwayat karte hai ke NABI-E-KAREM 
            صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne farmaya, " Jisne Quran padha aur uspe amal bhi kiya toh uske maa-baap
             ko qayamat ke din ek aisa Taj pehnaya jayega jiski roshni is duniya me logo ke gharo me chamakne 
             wale suraj ki roshni se zyada haseen hogi. Toh uske baare me tumhara kya khayal hai jisne
              khud ispar amal kiya ?"
            </p>
            <span className="referenceTag">[ SUNAN ABU DAWOOD : 1453 ]</span>
            <p className="contentSection_title--content">
            Hazrat Abu Hurairah رضی اللہ عنہ bayan karte ke Quran padho, Beshaq Qayamat ke din nihayat hi
             acha shafa'at karne wala hai. Qayamat ke din ye arz guzar hoga, "Aye Mere Rabb ! is
              (Quran padhne wale) shakhs ko izzat wala zewar pehna. Use izzat wala zewar pehnaya jayega.
               Aye Mere Rabb ! ise izzat wala Libas pehna. Use izzat wala libas pehnaya jayega. Aye Mere
                Rabb ! Ise izzat wala Taj pehna, Use Izzat wala Taj pehnaya jayega. Aye Mere Rabb ! Is se
                 raazi ho ja. Beshaq Teri Raza ke Baad koi cheez nahi bachti."
            </p>
            <span className="referenceTag">[ SUNAN DARMI : 3311 ]</span>
            <p className="contentSection_title--content">
            Hazrat Abdullah رضی اللہ عنہ bayan karte hain ke " Beshaq Quran ALLAH ka dastarkhwan hai,
             Pas jo is dastarkhwan me shamil ho gaya use amn naseeb ho gaya."
            </p>
            <span className="referenceTag">[ SUNAN DARMI : 3322 ]</span>
            <p className="contentSection_title--content">
            Hazrat Abdullah رضی اللہ عنہ bayan karte hain ke " Khushkhabri hai us shakhs ke liye jo
             Quran se Muhabbat karta hai."
            </p>
            <span className="referenceTag">[ SUNAN DARMI : 3323 ]</span>
            <p className="contentSection_title--content">
            Hazrat Jubair bin Nufair رضی اللہ عنہ bayan karte hain ke Huzur صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne irshad
             farmaya ki : " Beshaq tum Quran se badhkar afzal kisi aur cheez ke zariye ALLAH ki taraf hargiz 
             nahi lautoge."
            </p>
            <span className="referenceTag">[ SUNAN TIRMIZI : 2912 ]</span>
            <p className="contentSection_title--content">
            Hazrat Abu Hurairah رضی اللہ عنہ se riwayat hai ki Huzur صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne irshad
             farmaya ki : " Jo shakhs in (5 waqt ki) namazo ki hifazat kare wo ghaafileen me nahi likha
              jayega aur jisne raat ko 100 aayate tilawat ki wo farmabardar bando me likha jayega."
            </p>
            <span className="referenceTag">[ AL-MUSTADRAK : 1160 ]</span>
            <p className="contentSection_title--content">
            Hazrat Anas رضی اللہ عنہ se riwayat hai ki Huzur صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne irshad farmay ki : 
            " Logo me se kuch log ALLAH wale hote hai." Sahaba-e-ikraam ne arz kiya, YA RASULALLAH
             صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم, wo kaun log hai? AAP صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne farmaya, "Quran padhne wale.
              Wahi ALLAH wale aur uske khaas hain."
            </p>
            <span className="referenceTag">[ SUNAN AL KUBRA, : 8031 ]</span>
            <p className="contentSection_title--content">
            Hazrat Abu Hurairah رضی اللہ عنہ se riwayat hai ki Huzur صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne irshad farmaya
             ki : " Quran ki fazilat tamam kalamo par aisi hai jaise RAHMAN (ALLAH) ki fazilat uski tamam 
             makhluqat par hai."
            </p>
            <span className="referenceTag">[ SHUA'BUL IMAAN, : 2208 ]</span>
            <p className="contentSection_title--content">
            Hazrat Abdullah bin Amri رضی اللہ عنہ se riwayat hai ki Huzur صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne irshad
             farmaya ki : "Beshaq Quran ALLAH TA'ALA ko aasmano, zameen aur jo kuch unme hai sabse zyada 
             pyaara hai."
            </p>
            <span className="referenceTag">[ SUNAN DARMI, : 3358 ]</span>
         </div>
    </div>
  )
}

export default QuranShareef